export function clampAudioVolume(value:number){return Number.isFinite(value)?Math.max(0,Math.min(100,value)):100;}
export function openStreamMenu(event:{preventDefault:()=>void;stopPropagation:()=>void;clientX:number;clientY:number},participant:{identity:string;name?:string},leave:()=>void,open:(menu:{x:number;y:number;id:string;name:string;stream:true;leave:()=>void})=>void){
 event.preventDefault();event.stopPropagation();
 open({x:event.clientX,y:event.clientY,id:participant.identity,name:participant.name||participant.identity,stream:true,leave});
}
// Stream-only mute leaves speech audible. Muting a person (voice=0) silences all of their audio.
export function applyParticipantAudio(participant:{setVolume:(value:number,source:any)=>void},deafened:boolean,voice:number,stream:number,sources:{Microphone:any;ScreenShareAudio:any}){
 const muted=deafened||clampAudioVolume(voice)===0;
 let master=1;try{const raw=globalThis.localStorage?.getItem('malvo-output-volume');if(raw!==null&&raw!==undefined&&Number.isFinite(Number(raw)))master=Math.max(0,Math.min(100,Number(raw)))/100;}catch{}
 participant.setVolume(muted?0:clampAudioVolume(voice)/100*master,sources.Microphone);
 participant.setVolume(muted?0:clampAudioVolume(stream)/100*master,sources.ScreenShareAudio);
}

/** Keep music intact and ask Chromium/Electron to exclude the capturing app. */
export function streamAudioConstraints(enabled:boolean){
 return enabled?{echoCancellation:false,noiseSuppression:false,autoGainControl:false,restrictOwnAudio:true,suppressLocalAudioPlayback:false}:false;
}
export function watchingScreen(participant:any,screenSource:string){
 const screen=participant.getTrackPublication?.(screenSource);
 return !!screen?.isSubscribed&&screen.isDesired!==false&&!screen.isMuted;
}
